import { render, staticRenderFns } from "./AscHistogram.vue?vue&type=template&id=64135ca8&scoped=true&"
import script from "./AscHistogram.vue?vue&type=script&lang=js&"
export * from "./AscHistogram.vue?vue&type=script&lang=js&"
import style0 from "./AscHistogram.vue?vue&type=style&index=0&id=64135ca8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64135ca8",
  null
  
)

export default component.exports